// ollihess – Sale-Anzeige: hält Streichpreis und „−X %“-Badge beim Variantenwechsel aktuell.
// Die Rabatt-Prozente je Variante rendert snippets/price-list.liquid als JSON (data-oh-sale-map).
// Läuft nach den Theme-Handlern (Listener am document, variant:change bubbelt vom Formular hoch).

const readMap = (formId) => {
  const el = document.querySelector(`script[data-oh-sale-map="${CSS.escape(formId)}"]`);
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return null;
  }
};

const formatMoney = (cents) => {
  const s = window.themeVariables?.settings || {};
  const format = (s.currencyCodeEnabled ? s.moneyWithCurrencyFormat : s.moneyFormat) || '{{amount_with_comma_separator}} €';
  const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
  const kind = match ? match[1] : 'amount_with_comma_separator';
  const seps = {
    amount: [2, ',', '.'],
    amount_no_decimals: [0, ',', '.'],
    amount_with_space_separator: [2, ' ', '.'],
    amount_with_comma_separator: [2, '.', ','],
    amount_with_apostrophe_separator: [2, "'", '.'],
    amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_no_decimals_with_space_separator: [0, ' ', '.'],
  }[kind] || [2, '.', ','];
  const [precision, thousands, decimal] = seps;
  const [whole, frac] = (cents / 100).toFixed(precision).split('.');
  const value = whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`) + (frac ? decimal + frac : '');
  return format.replace(/\{\{\s*\w+\s*\}\}/, value);
};

const setLastChild = (el, text) => {
  if (el.lastChild) {
    el.lastChild.replaceWith(document.createTextNode(text));
  } else {
    el.append(text);
  }
};

document.addEventListener('variant:change', (event) => {
  const variant = event.detail?.variant;
  // Nicht form.id: Produktformulare haben ein <input name="id">, das die Eigenschaft überdeckt.
  const formId = event.target?.getAttribute?.('id');
  if (!formId || !variant) return;

  const map = readMap(formId);
  if (!map) return;

  const pct = Number(map.pct?.[variant.id] || 0);
  const nativeSale = variant.compare_at_price > variant.price;

  // Hinweis „Streichpreis: niedrigster Preis …“ nur zeigen, wenn wirklich ein Streichpreis steht
  document.querySelectorAll(`[data-oh-sale-note="${CSS.escape(formId)}"]`).forEach((el) => {
    el.hidden = !(pct > 0 || nativeSale);
  });

  if (pct <= 0 || nativeSale) return; // Theme-Handler haben bereits den Normal-/Vergleichspreis gesetzt

  const salePrice = variant.price - Math.round((variant.price * pct) / 100);
  const formSelector = `[form="${CSS.escape(formId)}"]`;

  document.querySelectorAll(`sale-price${formSelector}`).forEach((el) => {
    setLastChild(el, formatMoney(salePrice));
    el.classList.add('text-on-sale');
  });

  document.querySelectorAll(`compare-at-price${formSelector}`).forEach((el) => {
    setLastChild(el, formatMoney(variant.price));
    el.hidden = false;
  });

  document.querySelectorAll(`on-sale-badge${formSelector}`).forEach((el) => {
    el.textContent = (map.badge || '−@@ %').replace('@@', pct);
    el.hidden = false;
  });
});

// Mini-Badge „−X %“ an Farbfeldern, die stärker reduziert sind als die übrigen Varianten
// (z. B. Blau/Dunkelblau −30 %, Rest −20 %). Daten: dieselbe data-oh-sale-map + /products/<handle>.js.
const swatchStyle = () => {
  if (document.getElementById('oh-swatch-pct-style')) return;
  const st = document.createElement('style');
  st.id = 'oh-swatch-pct-style';
  st.textContent = '.oh-swatch-wrap{position:relative;display:inline-flex}.oh-swatch-pct{position:absolute;top:-7px;right:-9px;z-index:2;pointer-events:none;background:rgb(var(--on-sale-accent, 223 72 72));color:#fff;font-size:9px;font-weight:700;line-height:1;padding:3px 4px;border-radius:999px;white-space:nowrap;box-shadow:0 0 0 1.5px rgb(var(--background, 255 255 255))}.oh-opt-pct{display:inline-block;margin-inline-start:8px;vertical-align:middle;background:rgb(var(--on-sale-accent, 223 72 72));color:#fff;font-size:10px;font-weight:700;line-height:1;padding:3px 6px;border-radius:999px;white-space:nowrap}';
  document.head.append(st);
};

const productCache = {};
const loadProduct = (handle) => (productCache[handle] ||= fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null));

const decorateSwatches = async () => {
  const handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  if (!handle) return;
  const maps = document.querySelectorAll('script[data-oh-sale-map]');
  if (!maps.length) return;
  const product = await loadProduct(handle);
  if (!product) return;

  maps.forEach((el) => {
    const formId = el.getAttribute('data-oh-sale-map');
    const map = readMap(formId);
    if (!map?.pct) return;
    const pctOf = (v) => Number(map.pct[v.id] || 0);
    const min = Math.min(...product.variants.map(pctOf));

    product.options.forEach((_, i) => {
      const best = {};
      product.variants.forEach((v) => {
        const val = v.options[i];
        best[val] = Math.max(best[val] || 0, pctOf(v));
      });

      document.querySelectorAll(`input[type="radio"][name="option${i + 1}"]`).forEach((input) => {
        const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (!label || !label.classList.contains('color-swatch') || label.closest('.oh-swatch-wrap')) return;
        if (!input.id.includes(formId)) return;
        const pct = best[input.value] || 0;
        if (!(pct > min)) return;
        swatchStyle();
        const wrap = document.createElement('span');
        wrap.className = 'oh-swatch-wrap';
        label.before(wrap);
        wrap.append(label);
        const pill = document.createElement('span');
        pill.className = 'oh-swatch-pct';
        pill.setAttribute('aria-hidden', 'true');
        pill.textContent = (map.badge || '−@@ %').replace('@@', pct);
        wrap.append(pill);
      });

      // Dropdown-Auswahl (Popover-Listbox, z. B. S186): Pille hinter den Farbnamen
      document.querySelectorAll(`input[type="hidden"][name="option${i + 1}"][form="${CSS.escape(formId)}"]`).forEach((hidden) => {
        const listbox = hidden.closest('x-listbox');
        if (!listbox) return;
        listbox.querySelectorAll('.popover-listbox__option').forEach((btn) => {
          if (btn.querySelector('.oh-opt-pct')) return;
          const pct = best[btn.value] || 0;
          if (!(pct > min)) return;
          swatchStyle();
          const pill = document.createElement('span');
          pill.className = 'oh-opt-pct';
          pill.textContent = (map.badge || '−@@ %').replace('@@', pct);
          btn.append(pill);
        });
      });
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', decorateSwatches);
} else {
  decorateSwatches();
}
// Theme rendert die Variantenauswahl beim Wechsel teils neu → erneut dekorieren
document.addEventListener('variant:change', () => setTimeout(decorateSwatches, 50));
